import React from 'react';
import styled from 'styled-components';
import { ModalBody, ModalHeader } from 'reactstrap';

import OpusModal from '@monolith/components/0-atoms/OpusModal';
import {
    STAFF_IMPORT_FIELD_REQUIREMENTS,
    STAFF_IMPORT_PAGE_COPY,
} from '../constants/staffImport';

export interface StaffImportFieldRequirementsModalProps {
    isOpen: boolean;
    onClose: () => void;
}

const RequirementsTable = styled.table`
    width: 100%;
    border-collapse: collapse;
    font-family: 'Montserrat', sans-serif;
    font-size: 14px;
    line-height: 17px;
    color: #212121;
`;

const TableHeadCell = styled.th`
    padding: 12px 16px;
    text-align: left;
    font-weight: 600;
    border-bottom: 1px solid #e0e0e0;
`;

const TableCell = styled.td`
    padding: 12px 16px;
    border-bottom: 1px solid #e0e0e0;
    vertical-align: top;
`;

export const StaffImportFieldRequirementsModal: React.FC<
    StaffImportFieldRequirementsModalProps
> = ({ isOpen, onClose }) => {
    return (
        <OpusModal
            centered
            isOpen={isOpen}
            toggle={onClose}
            modalName="staff-import-field-requirements"
            wrapClassName="modal-primary modal-fit-content"
            size="lg"
        >
            <ModalHeader toggle={onClose}>
                {STAFF_IMPORT_PAGE_COPY.fieldRequirementsModalTitle}
            </ModalHeader>
            <ModalBody>
                <RequirementsTable>
                    <thead>
                        <tr>
                            <TableHeadCell>
                                {
                                    STAFF_IMPORT_PAGE_COPY.fieldRequirementsColumnAttribute
                                }
                            </TableHeadCell>
                            <TableHeadCell>
                                {
                                    STAFF_IMPORT_PAGE_COPY.fieldRequirementsColumnRequired
                                }
                            </TableHeadCell>
                            <TableHeadCell>
                                {
                                    STAFF_IMPORT_PAGE_COPY.fieldRequirementsColumnCsv
                                }
                            </TableHeadCell>
                        </tr>
                    </thead>
                    <tbody>
                        {STAFF_IMPORT_FIELD_REQUIREMENTS.map((row) => (
                            <tr key={row.csvColumn}>
                                <TableCell>{row.attributeName}</TableCell>
                                <TableCell>{row.requiredLabel}</TableCell>
                                <TableCell>{row.csvColumn}</TableCell>
                            </tr>
                        ))}
                    </tbody>
                </RequirementsTable>
            </ModalBody>
        </OpusModal>
    );
};

export default StaffImportFieldRequirementsModal;
